/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DescreditedProviderAliases {
  ACCESSIBILITY_0 = 'accessibility-0',
  ACCORDION_LEGENDS = 'accordion-legends',
  APPLICATION_BAR_0 = 'application-bar-0',
  AVATAR_USER = 'avatar-user',
  BUTTON_1 = 'button-1',
  BUTTON_2 = 'button-2',
  BUTTON_3 = 'button-3',
  BUTTON_4 = 'button-4',
  BUTTON_5 = 'button-5',
  BUTTON_6 = 'button-6',
  BUTTON_7 = 'button-7',
  BUTTON_8 = 'button-8',
  BUTTON_9 = 'button-9',
  BUTTON_10 = 'button-10',
  BUTTON_11 = 'button-11',
  BUTTON_12 = 'button-12',
  BUTTON_13 = 'button-13',
  BUTTON_14 = 'button-14',
  BUTTON_15 = 'button-15',
  BUTTON_16 = 'button-16',
  BUTTON_17 = 'button-17',
  BUTTON_18 = 'button-18',
  BUTTON_19 = 'button-19',
  BUTTON_20 = 'button-20',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FIELD_DT_END_PROVIDER = 'field-dtEndProvider',
  FIELD_DT_PUBLISHED = 'field-dtPublished',
  FIELD_NAME = 'field-name',
  FRAGMENT_FOOTER = 'fragment-footer',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPE_D = 'hpms-custom-card-content-collape-D',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPE_S = 'hpms-custom-card-content-collape-S',
  HPMS_DYNAMIC_CONTENT_D = 'hpms-dynamic-content-D',
  HPMS_DYNAMIC_CONTENT_S = 'hpms-dynamic-content-S',
  MAPPER_USER = 'mapper-user',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_7 = 'panel-7',
  PANEL_8 = 'panel-8',
  PANEL_9 = 'panel-9',
  PANEL_10 = 'panel-10',
  PANEL_11 = 'panel-11',
  PANEL_12 = 'panel-12',
  PANEL_13 = 'panel-13',
  PANEL_14 = 'panel-14',
  PANEL_15 = 'panel-15',
  PANEL_16 = 'panel-16',
  PANEL_17 = 'panel-17',
  PANEL_18 = 'panel-18',
  PANEL_19 = 'panel-19',
  PANEL_20 = 'panel-20',
  PANEL_21 = 'panel-21',
  PANEL_22 = 'panel-22',
  PANEL_23 = 'panel-23',
  PANEL_24 = 'panel-24',
  PANEL_30 = 'panel-30',
  PANEL_31 = 'panel-31',
  PANEL_32 = 'panel-32',
  PANEL_405 = 'panel-405',
  PANEL_ACREDITACAO = 'panel-acreditacao',
  PANEL_CONTENT = 'panel-content',
  PANEL_LABELS = 'panel-labels',
  ROOT_COMPONENT = 'root-component',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_20 = 'text-20',
  TEXT_21 = 'text-21',
  TEXT_22 = 'text-22',
  TEXT_23 = 'text-23',
  TEXT_24 = 'text-24',
  TEXT_25 = 'text-25',
  TEXT_26 = 'text-26',
  TEXT_DT_END_PROVIDER = 'text-dtEndProvider',
  TEXT_DT_PUBLISHED = 'text-dtPublished',
}
export { DescreditedProviderAliases };
